import { useEffect, useState } from "react";
import { ProgressSpinner } from 'primereact/progressspinner';
import DataTableView from "./dataTable";
import { Submission, Requirement, ECIs, POs, Margin } from "./DashboardModel";
import { getBranchECIs, getBranchMargins, getBranchPOs, getBranchRequirments, getBranchSubmissions } from "./BranchData";
import { IPermissionProps } from "../../models/Login";
import { Navigate } from "react-router-dom";


export const Branch = (permissions : IPermissionProps) => {
    const [branchRequirements, setBranchRequirements] = useState<Array<Requirement>>([]);
    const [branchSubmissions, setBranchSubmissions] = useState<Array<Submission>>([]);
    const [branchECI, setBranchECI] = useState<Array<ECIs>>([]);
    const [branchPO, setBranchPO] = useState<Array<POs>>([]);
    const [branchMargim, setBranchMargin] = useState<Array<Margin>>([]);


    useEffect(() => {
        const getBranchData = async () => {

            const RespBranchReq = await getBranchRequirments();
            const RespBranchSub = await getBranchSubmissions();
            const RespBranchEci = await getBranchECIs();
            const RespBranchPo = await getBranchPOs();
            const RespBranchMargin = await getBranchMargins();

            setBranchRequirements(RespBranchReq);
            setBranchSubmissions(RespBranchSub);
            setBranchECI(RespBranchEci);
            setBranchPO(RespBranchPo);
            setBranchMargin(RespBranchMargin);
        }
        getBranchData();

    }, []);

    return (
        permissions.is_View ? <div>
            {branchRequirements.length > 0 && branchSubmissions.length > 0 && <DataTableView ReqData={branchRequirements} SubData={branchSubmissions} ECIData={[]} POData={[]} MarginData={[]} which={"ReqSub"} tabOf={"branch"} />}
            {branchRequirements.length === 0 && branchSubmissions.length === 0 && <ProgressSpinner className="m-auto left-50 mt-8" />}
            {branchRequirements.length > 0 && branchSubmissions.length > 0 && <DataTableView ReqData={[]} SubData={[]} ECIData={branchECI} POData={branchPO} MarginData={[]} which={"EciPo"} tabOf={"branch"} />}
            {branchRequirements.length > 0 && branchSubmissions.length > 0 && <DataTableView ReqData={[]} SubData={[]} ECIData={[]} POData={[]} MarginData={branchMargim} which={"Margin"} tabOf={"branch"} />}
        </div> : <></>
    )
}


